/**
 * Scrolls to an in-page section and syncs the URL fragment.
 *
 * `next/link` and `location.hash = …` both do nothing when the requested
 * fragment is already the current one, so a nav link or CTA pointing at
 * `#pricing` goes dead as soon as the reader scrolls away from that section by
 * hand. Driving the scroll ourselves keeps repeat clicks working.
 *
 * Returns false when the section is not on this page, so the caller can fall
 * back to normal navigation.
 */
export function scrollToAnchor(href: string): boolean {
  const id = href.startsWith("#") ? href.slice(1) : href;
  if (!id || typeof document === "undefined") return false;

  const target = document.getElementById(id);
  if (!target) return false;

  // `scroll-padding-top` in globals.css keeps the sticky header clear.
  target.scrollIntoView({ behavior: "smooth", block: "start" });

  const hash = `#${id}`;
  if (window.location.hash !== hash) window.history.pushState(null, "", hash);

  return true;
}
